import React, { Component } from "react";
import { Segment, Statistic, Popup, Icon, Divider, Header } from "semantic-ui-react";
import Constants from "utilities/Constants";
import Strings from "utilities/StringSelector";
import Utils from "utilities/Utils";

const UtilsInstance = new Utils();
class TrafficStatistics extends Component {

  // Intialize this component state
  constructor(props) {
    super(props);

    this.state = {
      statistics: [],
      // Controller para cancelar requests caso saia da tela
      controller: new AbortController()
    };
  }

  retrieveData = () => {
    // Statistics data
    fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "trafficStatistics", { mode: "cors", signal: this.state.controller.signal })
      .then(res => res.json())
      .then(data => this.setState({ statistics: data, }, () => {
        this.setBaudRateQuantity();
        this.setCycleTime();
      }))
      .catch((e) => {
        console.log("TrafficStatistics request interrupted: ", e);
      });
  }

  setBaudRateQuantity = () => {
    const lang = localStorage.getItem(Constants.LOCAL_STORAGE_KEY);

    let baudRateKbps = (this.state.statistics.baudRate / 1000).toString();
    let baudRateMbps = (this.state.statistics.baudRate / 1000000).toString();

    let baudRateKbpsText = baudRateKbps.toString();
    let baudRateMbpsText = baudRateMbps.toString();

    if (lang !== Constants.EN_LANG_KEY) {
      baudRateKbpsText = UtilsInstance.replacePointWithComma(baudRateKbpsText);
      baudRateMbpsText = UtilsInstance.replacePointWithComma(baudRateMbpsText);
    }

    // If the baur rate is greater then 1000 Kbps show it as Mbps
    if (baudRateKbps >= 1000.00) {
      document.getElementById("baud_rate_speed").innerHTML = baudRateMbpsText;
      document.getElementById("baud_rate_order_of_magnitude").innerHTML = Strings.BAUD_RATE_MBPS;
    }
    else {
      document.getElementById("baud_rate_speed").innerHTML = baudRateKbpsText;
      document.getElementById("baud_rate_order_of_magnitude").innerHTML = Strings.BAUD_RATE_KBPS;
    }
  }

  setCycleTime = () => {
    const lang = localStorage.getItem(Constants.LOCAL_STORAGE_KEY);

    const cycleTimeMs = parseFloat(this.state.statistics.cycleTime);
    const cycleTimeS = parseFloat(this.state.statistics.cycleTime) / 1000;

    let cycleTimeMsText = cycleTimeMs.toFixed(2);
    let cycleTimeSText = cycleTimeS.toFixed(2);

    if (lang !== Constants.EN_LANG_KEY) {
      cycleTimeMsText = UtilsInstance.replacePointWithComma(cycleTimeMsText);
      cycleTimeSText = UtilsInstance.replacePointWithComma(cycleTimeSText);
    }

    if (cycleTimeMs >= 1000.00) {
      document.getElementById("cycle_time").innerHTML = cycleTimeSText;
      document.getElementById("cycle_time_order_of_magnitude").innerHTML = Strings.CYCLE_TIME_S;
    }
    else {
      document.getElementById("cycle_time").innerHTML = cycleTimeMsText;
      document.getElementById("cycle_time_order_of_magnitude").innerHTML = Strings.CYCLE_TIME_MS;
    }
  }

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    this.retrieveData();
    // store intervalId in the state so it can be accessed later
    this.setState({ intervalID: setInterval(this.retrieveData, 5000) });
  }

  componentWillUnmount() {
    this.state.controller.abort();
    clearInterval(this.state.intervalID);
  }

  render() {
    return (
      <Segment style={segmentStyle}>

        <Header as='h3' textAlign="center" color="teal">
          {Strings.PROFIBUS_NETWORK_INFO}
        </Header>
        <Divider style={{ marginTop: "-8px" }} />

        <Statistic.Group size="small" widths={5}>
          <Statistic>
            <Statistic.Value id="baud_rate_speed"></Statistic.Value>
            <Statistic.Label id="baud_rate_order_of_magnitude" style={statisticLabelStyle}>{Strings.BAUD_RATE_KBPS}</Statistic.Label>
          </Statistic>

          <Statistic>
            <Statistic.Value id="cycle_time"></Statistic.Value>
            <Statistic.Label id="cycle_time_order_of_magnitude" style={statisticLabelStyle}>{Strings.CYCLE_TIME_MS}</Statistic.Label>
          </Statistic>

          <Statistic>
            <Statistic.Value>{this.state.statistics.watchdog > 0 ? this.state.statistics.watchdog : "-"}</Statistic.Value>
            <Statistic.Label style={statisticLabelStyle}>
              {Strings.WATCHDOG_MS}
              <Popup position="top right" hoverable pinned wide
                trigger={<Icon style={popupStyle} name="question circle" color="teal" />}>
                <Popup.Content>
                  <p>{Strings.WATCHDOG_QUESTION_INFO_1}</p>
                  <p>{Strings.WATCHDOG_QUESTION_INFO_2}</p>
                  <p>{Strings.WATCHDOG_QUESTION_INFO_3}</p>
                </Popup.Content>
              </Popup >
            </Statistic.Label>
          </Statistic>

          <Statistic>
            <Statistic.Value>{this.state.statistics.retryLimit > 0 ? this.state.statistics.retryLimit : "-"}</Statistic.Value>
            <Statistic.Label>
              {Strings.RETRIES_LIMIT}
            </Statistic.Label>
          </Statistic>

          <Statistic>
            <Statistic.Value>{this.state.statistics.hsa}</Statistic.Value>
            <Statistic.Label>
              HSA
              <Popup position="top right" hoverable pinned wide
                trigger={<Icon style={popupStyle} name="question circle" color="teal" />}>
                <Popup.Content>
                  <p>{Strings.HSA_POPUP_1}</p>
                  <p>{Strings.HSA_POPUP_2}</p>
                </Popup.Content>
              </Popup >
            </Statistic.Label>
          </Statistic>
        </Statistic.Group>

      </Segment>
    );
  }
}

const segmentStyle = {
  textAlign: "center"
};

const statisticLabelStyle = {
  textTransform: "none"
};

const popupStyle = {
  marginLeft: "4px"
};

export default TrafficStatistics;

